export const not = (s) => !s;
export const and = (value) => (s) => s && !!value;
export const or = (value) => (s) => s || !!value;
// alias
export const toggle = not;
//# sourceMappingURL=boolean.js.map